<template>
  <div class="loaderBar" :style="dimensions">
    <svg class="circular" viewBox="25 25 50 50">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="4"
        stroke-miterlimit="10"
      ></circle>
    </svg>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";

/**
 * @vuese
 * @group Loaders
 * This is animated circular loader.
 */
export default {
  name: "LoaderCircular",
  mixins: [BaseComponent],
  props: {
    height: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    dimensions() {
      return {
        width: `${this.height}px`,
        height: `${this.height}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.loaderBar {
  position: relative;
  &:before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}

.circular {
  animation: rotate 1s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 2.5s ease-in-out infinite;
  stroke: $blue;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>
